export default function handlerErrorMP(payment) {
  let message = '';
  if (payment){
    let detail = 'detail' in payment ? payment.detail : payment.detalhe;

    switch (detail) {
      //resposta de transação
      case 'cc_rejected_bad_filled_card_number': message = 'Revise o número do cartão.'; break;
      case 'cc_rejected_bad_filled_date': message = 'Revise a data de vencimento.'; break;
      case 'cc_rejected_bad_filled_other': message = 'Revise os dados.'; break;
      case 'cc_rejected_bad_filled_security_code': message = 'Revise o código de segurança do cartão.'; break;
      case 'cc_rejected_blacklist': message = 'Não pudemos processar seu pagamento.'; break;
      case 'cc_rejected_call_for_authorize': message = 'Você deve autorizar ao :payment_method_id o pagamento do valor.'; break;
      case 'cc_rejected_card_disabled': message = 'Ligue para o :payment_method_id para ativar seu cartão. O telefone está no verso do seu cartão.'; break;
      case 'cc_rejected_card_error': message = 'Não conseguimos processar seu pagamento.'; break;
      case 'cc_rejected_duplicated_payment': message = 'Você já efetuou um pagamento com esse valor. Caso precise pagar novamente, utilize outro cartão ou outra forma de pagamento. Seu pagamento foi recusado.'; break;
      case 'cc_rejected_high_risk': message = 'Escolha outra forma de pagamento.'; break;
      case 'cc_rejected_insufficient_amount': message = 'O :payment_method_id possui saldo insuficiente.'; break;
      case 'cc_rejected_invalid_installments': message = 'O :payment_method_id não processa pagamentos em :installments parcelas.'; break;
      case 'cc_rejected_max_attempts': message = 'Você atingiu o limite de tentativas permitido. Escolha outro cartão ou outra forma de pagamento'; break;
      case 'cc_rejected_other_reason': message = ':payment_method_id: não processa o pagamento.'; break;
      case 'cc_rejected_card_type_not_allowed': message = 'O pagamento foi rejeitado porque o usuário não tem a função crédito habilitada em seu cartão multiplo (débito e crédito).'; break;
      case 'pending_waiting_transfer': message = 'Aguardando Aprovação'; break;
      case 'cc_rejected_3ds_challenge': message = 'Transação rejeitada devido a falha no Challenge'; break;
      case 'expired': message = 'Expirado'; break;
      case 'unexpected_error': 'Error inesperado'; break;
      // Erros de inserção de dados
      case '205': message = 'Digite o número do seu cartão.'; break;
      case '208': message = 'Escolha um mês.'; break;
      case '209': message = 'Escolha um ano.'; break;
      case '212': message = 'Informe seu documento.'; break;
      case '214': message = 'Informe seu documento.'; break;
      case '220': message = 'Informe seu banco emissor.'; break;
      case '221': message = 'Digite o nome e sobrenome.'; break;
      case '224': message = 'Digite o código de segurança.'; break;
      case 'E203': message = 'Confira o código de segurança.'; break;
      case 'E301': message = 'Há algo de errado com esse número. Digite novamente.'; break;
      case '316': message = 'Por favor, digite um nome válido.'; break;
      case '322': message = 'Confira seu documento.'; break;
      case '324': message = 'Confira seu documento.'; break;
      case '325': message = 'Confira a data.'; break;
      case '326': message = 'Confira a data.'; break;
    }


    let result = message.replace(':payment_method_id', payment.methodPayment);

    return result;
  }
  return 'error';
}
